import React from 'react'

import {
  Button, Close, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

function ShareModalHeader({ closeModal }) {
  return (
    <div className="share-modal__header">
      <h1 className="share-modal__title">Share this model</h1>
      <div className="share-modal__close-button-container">
        <Button
          size="small"
          type="ghost"
          variant="only-icon"
          customClass="share-modal__close-button"
          onClick={closeModal}
          icon={<Icon svgComponent={Close} />}
        />
      </div>
    </div>
  )
}

ShareModalHeader.propTypes = {
  closeModal: func.isRequired,
}

export default ShareModalHeader
